export default __webpack_public_path__ + "static/media/4.8f7c28b8.jpg";